const SPLIT_SEPARATOR = ':' as const;

export const getNameDerivedQuickControlTitle = (str: string) => {
  const items = str.split(SPLIT_SEPARATOR);

  if (items.length === 2) return items[1].trim(); // specifically return the part after the colon
  return items[0]?.trim();
};

export const getNameDerivedQuickControlSubtitle = (str: string, fallback?: string) => {
  const items = str.split(SPLIT_SEPARATOR);

  if (items.length === 2) return items[0].trim(); // specifically return the part before the colon
  return items[1]?.trim() || fallback?.trim();
};
